import { render, staticRenderFns } from "./DelTask.vue?vue&type=template&id=97b978c8&scoped=true"
import script from "./DelTask.vue?vue&type=script&lang=js"
export * from "./DelTask.vue?vue&type=script&lang=js"
import style0 from "./DelTask.vue?vue&type=style&index=0&id=97b978c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b978c8",
  null
  
)

export default component.exports